import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getDocuments, createDocument, updateDocument, deleteDocument } from "../api";
import { useNotification } from "../../../contexts/NotificationContext";

export const useGetDocuments = (type = "") => {
  return useQuery({
    queryKey: ["documents"],
    queryFn: () => getDocuments(type),
  });
};

export const useCreateDocument = () => {
  const queryClient = useQueryClient();
  const { showNotification } = useNotification();

  return useMutation({
    mutationFn: ({ data, files }) => createDocument(data, files),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["documents"] });
      showNotification('success', 'Document created successfully!');
    },
    onError: (error) => {
      console.error("Error creating document:", error);
      let errorMessage = 'Error creating document. Please try again.';
      if (error?.response?.data?.error?.message) {
        errorMessage = error.response.data.error.message;
      } else if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error?.message) {
        errorMessage = error.message;
      }
      showNotification('danger', errorMessage);
    },
  });
};

export const useUpdateDocument = () => {
  const queryClient = useQueryClient();
  const { showNotification } = useNotification();

  return useMutation({
    mutationFn: ({ id, data, files }) => updateDocument(id, data, files),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["documents"] });
      showNotification('success', 'Document updated successfully!');
    },
    onError: (error) => {
      console.error("Error updating document:", error);
      let errorMessage = 'Error updating document. Please try again.';
      if (error?.response?.data?.error?.message) {
        errorMessage = error.response.data.error.message;
      } else if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error?.message) {
        errorMessage = error.message;
      }
      showNotification('danger', errorMessage);
    },
  });
};

export const useDeleteDocument = () => {
  const queryClient = useQueryClient();
  const { showNotification } = useNotification();

  return useMutation({
    mutationFn: (id) => deleteDocument(id),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["documents"] });
      showNotification('success', 'Document deleted successfully!');
    },
    onError: (error) => {
      console.error("Error deleting document:", error);
      let errorMessage = 'Error deleting document. Please try again.';
      if (error?.response?.data?.error?.message) {
        errorMessage = error.response.data.error.message;
      } else if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error?.message) {
        errorMessage = error.message;
      }
      showNotification('danger', errorMessage);
    },
  });
};